import { Injectable, NgZone } from '@angular/core';
import { fromEvent, merge, Observable, shareReplay, startWith } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class MonitorNetworkService {
  public readonly isOnline$: Observable<boolean> = merge(
    fromEvent(window, 'online').pipe(map(() => true)),
    fromEvent(window, 'offline').pipe(map(() => false))
  ).pipe(startWith(navigator.onLine), shareReplay(1));
}
